export const APP_ENTRYPOINT = process.env.REACT_APP_ENTRYPOINT;
export const APP_LOGIN_PATH = "token";
export const APP_REFRESH_TOKEN_PATH = "token/refresh";
export const IMAGE_RESOURCE = "images";
export const FILE_SIZE = 10485760;
